import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {CartItem, OnDestroySubject} from 'src/app/data/model';
import {Observable, takeUntil} from 'rxjs';

import * as cartSelectors from 'src/app/common/shopping-cart/cart.selectors';
import {filterNullOrUndefined} from 'src/app/common/service';
import {TaxEstimation} from '@sportngin/se-commerce-sdk';
import {getCartTax} from '../../cart.actions';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {class: 'app-checkout'},
  standalone: false,
})
export class CheckoutComponent extends OnDestroySubject implements OnInit {
  cartItems$: Observable<CartItem[]>;
  taxEstimate$: Observable<TaxEstimation | undefined>;

  constructor(private store: Store) {
    super();
    this.cartItems$ = this.store.select(
      cartSelectors.selectCartItemsForDisplay,
    );
  }

  ngOnInit(): void {
    this.cartItems$.pipe(takeUntil(this.onDestroy)).subscribe(items => {
      const taxable = items.some(item => item.templateKey === 'yso-products');
      if (taxable) {
        this.store.dispatch(getCartTax());
      }
    });
    this.taxEstimate$ = this.store.pipe(
      select(cartSelectors.selectTax),
      filterNullOrUndefined(),
    );
  }
}
